module.exports = "/_next/static/images/2b2ba7c4fac64289e3833881047c37cd-blog-15x.jpg.webp";